 import { AmbassadorPromotionLevelEnum } from "projects/admin/src/app/shared/models/enums/AmbassadorPromotionLevelEnum"
import { SubscriptionTypeEnum } from "./enum/SubscriptionTypeEnum"
import { UserTypeEnum } from "./enum/UserTypeEnum"

export class MembershipInfo {
  membershipNumber!: string
  fullName!: string
  membershipType!: UserTypeEnum
  subscriptionTypeEnum!: SubscriptionTypeEnum | null
  identityNumber!: string
  joinedDate!: string
  ambassadorLevel!:AmbassadorPromotionLevelEnum
}
